/*
 * Select
 * @module components
 * @flow
 */
import styled, { css } from 'styled-components/macro';
import { ifProp } from 'styled-tools';
import { palette } from 'styled-theme';
// $FlowIssue
import ReactSelect from 'react-select';
// $FlowIssue
import ReactSelectCreatable from 'react-select/creatable';

const getWidth = ({ type, rounded }) =>
  type === 'number' && !rounded ? '68px;' : 'auto';

const controlStyles = ({ rounded }) =>
  rounded
    ? css`
        border-color: ${palette('primary', 5)};
        border-width: 1px;
        border-radius: 30px;
        padding: 0 19px;
        font-size: 22px;
        font-weight: bold;

        &:hover {
          border-color: ${palette('primary', 5)};
        }

        input {
          color: ${palette('primary', 5)} !important;
        }
      `
    : css`
        border-width: 0;
        border-color: ${palette('grayscale', 2)};
        border-bottom-width: 1px;
        border-radius: 0;
      `;

/**
 * Select React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.type] - default range value
 * @param {Object} [props.options] - possible options
 * @param {Object} [props.value] - selected value
 * @param {boolean} [props.rounded] - selected value
 * @param {boolean} [props.top]  - menu opens on top
 * @example <caption>Simple usage</caption>
 * <Select value={{value: 1}} />
 * @returns {React.Node<*>} React-component
 */

const styleSelect = (Component, attrs) => styled(Component).attrs(() => ({
  className: 'react-select',
  classNamePrefix: 'react-select',
  testid: 'select',
  ...attrs,
}))`
  width: ${getWidth};
  ${ifProp(
    'isDisabled',
    css`
      opacity: 0.5;
      pointer-events: none;
    `,
  )};

  .react-select {
    &__value-container,
    &__single-value {
      color: currentColor;
    }

    &__value-container {
      min-width: 35px;
    }

    &__control {
      background-color: ${ifProp('rounded', '#fff', 'transparent')};
      border-style: solid;

      ${controlStyles};

      &--is-focused {
        border-color: ${palette('primary', 1)};
        box-shadow: none;
      }
    }

    &__indicator {
      padding: 0;
      color: currentColor;

      svg {
        width: 14px;
        height: 14px;
      }
    }

    &__indicator-separator {
      display: none;
    }

    &__menu {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid ${palette('grayscale', 2)};
      box-shadow: none;

      ${ifProp(
        'top',
        css`
          top: auto;
          bottom: 100%;
        `,
      )};
    }

    &__option {
      cursor: pointer;
      color: ${palette('grayscale', 1)};
    }

    &__option:hover,
    &__option--is-selected,
    &__option--is-focused {
      background-color: #f4fbff;
    }
  }
`;

export const Select = styleSelect(ReactSelect, { isSearchable: false });
export const CreatableSelect = styleSelect(ReactSelectCreatable, {});

Select.defaultProps = {
  placeholder: '',
  type: 'number',
  testid: 'select',
};

CreatableSelect.defaultProps = {
  placeholder: '',
  type: 'number',
  testid: 'select',
};
